import { close, notify } from "../features/snackbarSlice";
import { store } from "../store";

export async function notifyService(message) {
  store.dispatch(notify(message));
  setTimeout(() => store.dispatch(close()), 2000)
}
